var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRegularPowerOffGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1611 12.2903C13.1611 12.9327 12.6421 13.4516 11.9998 13.4516C11.3574 13.4516 10.8385 12.9327 10.8385 12.2903V4.16129C10.8385 3.52004 11.3574 3 11.9998 3C12.6421 3 13.1611 3.52004 13.1611 4.16129V12.2903ZM5.61268 12.2903C5.61268 15.8177 8.47236 18.6774 11.9998 18.6774C15.5272 18.6774 18.3869 15.8177 18.3869 12.2903C18.3869 10.3161 17.4905 8.54879 16.0824 7.37661C15.5889 6.96653 15.5199 6.23456 15.93 5.74137C16.3401 5.24819 17.0732 5.18105 17.5667 5.59113C19.4828 7.1879 20.7095 9.59758 20.7095 12.2577C20.7095 17.0988 16.8082 21 11.9998 21C7.19131 21 3.2901 17.0988 3.2901 12.2577C3.2901 9.59758 4.5149 7.1879 6.43284 5.59113C6.92639 5.18105 7.65946 5.24819 8.06954 5.74137C8.44696 6.23456 8.41067 6.96653 7.91712 7.37661C6.50905 8.54879 5.61268 10.3161 5.61268 12.2903Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegularPowerOffGrey);
export default __webpack_public_path__ + "static/media/icon-regular-power-off-grey.be596047b1f80f30b0e28c5931ba5d3b.svg";
export { ForwardRef as ReactComponent };